import axios from "axios";
import { getApiURL, axiosTimeout } from "@/config";
// 'Access-Control-Allow-Origin': '*',
// 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
// let token = "";
let api = null;
let forLogin = null;
let wfApi = null;
let citycenterApi = null;
function buildApi() {
  // token = getLocalStorageItem("eap-bearer-token");
  const employeeAccessApiUrl = getApiURL("employeeAccessApiUrl");
  const cityCenterApiUrl = getApiURL("cityCenterApiUrl");
  const workFlowApiUrl = getApiURL("workFlowApiUrl");
  api = axios.create({
    baseURL: employeeAccessApiUrl,
    // withCredentials: true,
    headers: {
      Accept: "text/plain",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache"
    },
    timeout: Number(axiosTimeout)
  });

  forLogin = axios.create({
    baseURL: employeeAccessApiUrl,
    // withCredentials: true,
    headers: {
      Accept: "text/plain",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache"
    },
    timeout: Number(axiosTimeout)
  });

  wfApi = axios.create({
    baseURL: workFlowApiUrl,
    // withCredentials: true,
    headers: {
      Accept: "text/plain",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      "Access-Control-Allow-Origin": "*"
    },
    timeout: Number(axiosTimeout)
  });
  citycenterApi = axios.create({
    baseURL: cityCenterApiUrl,
    // withCredentials: true,
    headers: {
      Accept: "text/plain",
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      "Access-Control-Allow-Origin": "*"
    },
    timeout: Number(axiosTimeout)
  });
  citycenterApi.interceptors.request.use(config => config);
  wfApi.interceptors.request.use(config => config);
  api.interceptors.request.use(
    config => config,
    error => Promise.reject(error.message)
  );
  api.interceptors.response.use(
    response => response,
    error => Promise.reject(error.message)
    // error => {
    //   if (error.response.status === 401) {
    //     setLocalStorageItem("eapLoggedIn", JSON.stringify(false));
    //     window.dispatchEvent(
    //       new CustomEvent("eap-loggedIn-localstorage-changed", {
    //         detail: {
    //           storage: localStorage.getItem("eapLoggedIn")
    //         }
    //       })
    //     );
    //   }
    //   // if (error.response && error.response.data) {
    //   //   //add your code
    //   //   console.log(error.response.data);
    //   //   return Promise.reject(error.response.data);
    //   // }
    //   return Promise.reject(error.message);
    // }
  );

  forLogin.interceptors.response.use(response => response);
}
const updateAuthorization = keycloak => {
  // console.log(keycloak);
  const authHeaderValue = `Bearer ${keycloak.token}`;
  api.defaults.headers.common["Authorization"] = authHeaderValue;
  wfApi.defaults.headers.common["Authorization"] = authHeaderValue;
  citycenterApi.defaults.headers.common["Authorization"] = authHeaderValue;
};

export default {
  getPersonnelActions: () => api.get(`/PersonnelAction`),
  getPersonnelChanges: () => api.get(`/PersonnelChange`),
  getTimeEntries: () => api.get(`/TimeEntry`),
  getLeaveRequests: (url = "", c) => api.get(url + "/" + c),
  getLeaveBalance: (url = "", c) => api.get(url + "/" + c),
  getTimeSheets: () => api.get(`/TimeSheet`),
  getUserDetail: (url = "", c) => api.get(url + "/" + c),
  get: (url = "", item) => api.get(url + "/" + item),
  post: (url = "", item) => api.post(url, JSON.stringify(item)),
  loginPost: (url = "", c) => forLogin.post(url, JSON.stringify(c)),
  logOutPost: (url = "") => wfApi.post(url),
  wfApiGet: (url = "", item) => wfApi.get(url + "/" + item),
  wfApiGetWithoutPayload: (url = "") => wfApi.get(url),
  wfApiPost: (url = "", c) => wfApi.post(url, c),
  wfApiPatch: (url = "", c) => wfApi.patch(url, c),
  cityCenterApiGet: (url = "", item) => citycenterApi.get(url + "/" + item),
  cityCenterApiGetWithoutPayload: (url = "") => citycenterApi.get(url),
  cityCenterApiPost: (url = "", c) =>
    citycenterApi.post(url, JSON.stringify(c)),
  loginPostAuto: (url = "", c) => api.post(url, JSON.stringify(c)),
  put: (url = "", c) => api.put(url, c),
  getWithoutPayload: (url = "") => api.get(url).catch(e => Promise.reject(e)),
  delete: (url = "", item) => api.delete(url, { data: item }),
  updateAuthorization: keycloak => updateAuthorization(keycloak)
};
export { buildApi };
